module.exports = __webpack_public_path__ + "static/media/node.9b2abf6e.png";